import React from 'react';
export function EnginesServiced() {
  const engines = ['6.0L', '6.4L', '6.7L', '7.3L'];
  return <section className="bg-slate-100 py-12 border-y border-slate-200" data-id="element-164" data-mp="rpq9zj20gtpq">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165" data-mp="15ozmo8r0d5oy">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12" data-id="element-166" data-mp="15og6awh0apd1">
          <h3 className="text-lg font-bold text-slate-500 uppercase tracking-widest" data-id="element-167" data-mp="11nw61k14z5mo">
            Powerstroke Generations We Service:
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-168" data-mp="8yz3cp9erhf1">
            {engines.map(engine => <div key={engine} className="px-6 py-2 bg-white border-2 border-slate-200 rounded-full font-display text-2xl text-dark shadow-sm" data-id="element-169" data-mp="mqnccjod1prs">
                {engine}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}